exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* IE fix */\n#card-chart-01,\n#card-chart-02 {\n\twidth: 100% !important;\n}\n", ""]);

// exports
